<div class="container mt-4">
  <div id="accordion">
    <!-- Request Step -->
    <div class="card" *ngIf="requestStepVisible">
      <div class="card-header" id="headingRequestStep">
        <div class="d-flex justify-content-between">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              [attr.aria-expanded]="expandedStep === InspectionStep.Request"
              (click)="expandRequestStep()"
            >
              Request {{ activity.model.inspectionType }} Inspection
            </button>
          </h5>
          <span
            *ngIf="activity.requestStepSubmitted"
            class="text-success ml-2"
            title="Submitted"
          >
            &#10003;
          </span>
          <span
            *ngIf="!activity.requestStepSubmitted"
            class="text-muted ml-2"
            title="Not submitted"
          >
            &#9711;
          </span>
        </div>
      </div>
      <div
        [ngClass]="{
          collapse: expandedStep !== InspectionStep.Request,
          show: expandedStep === InspectionStep.Request
        }"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <wm-form-activity-input-view
                #requestStepInput
                [activity]="activity.model.requestStepActivity"
                [calculationActivity]="activity"
                [form]="requestStepForm"
                [applicationId]="applicationId"
              ></wm-form-activity-input-view>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            @if(!templateForPermitForm){
            <button
              class="btn btn-primary btn-raised"
              [disabled]="
                activity.requestStepSubmitted ||
                requestStepForm.invalid ||
                processing
              "
              (click)="submitRequestStep()"
            >
              {{
                activity.requestStepSubmitted
                  ? 'Request Submitted'
                  : 'Submit Request'
              }}
            </button>
            }@else{
            <wm-common-button
              class="inspection-button"
              [data]="{
                text:activity.requestStepSubmitted
                  ? 'Request Submitted'
                  : 'Submit Request',
                disabled: activity.requestStepSubmitted 
                  || requestStepForm.invalid
                  || processing,
                onClick: submitRequestStep.bind(this)
              }"
            >
            </wm-common-button>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Schedule Step -->
    <div class="card" *ngIf="scheduleStepVisible">
      <div class="card-header" id="headingScheduleStep">
        <div class="d-flex justify-content-between">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              [attr.aria-expanded]="expandedStep === InspectionStep.Schedule"
              (click)="expandScheduleStep()"
            >
              Schedule {{ activity.model.inspectionType }} Inspection
            </button>
          </h5>
          <span
            *ngIf="activity.scheduleStepSubmitted"
            class="text-success ml-2"
            title="Submitted"
          >
            &#10003;
          </span>
          <span
            *ngIf="!activity.scheduleStepSubmitted"
            class="text-muted ml-2"
            title="Not submitted"
          >
            &#9711;
          </span>
        </div>
      </div>
      <div
        [ngClass]="{
          collapse: expandedStep !== InspectionStep.Schedule,
          show: expandedStep === InspectionStep.Schedule
        }"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <wm-form-activity-input-view
                #scheduleStepInput
                [activity]="activity.model.scheduleStepActivity"
                [calculationActivity]="activity"
                [form]="scheduleStepForm"
                [applicationId]="applicationId"
              ></wm-form-activity-input-view>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            @if(!templateForPermitForm){

            <button
              class="btn btn-primary btn-raised"
              [disabled]="
                activity.model.inspection.downloadedToTabletOn ||
                uploadedInspectionPending ||
                scheduleStepForm.invalid ||
                processing
              "
              (click)="submitScheduleStep()"
            >
              {{
                activity.scheduleStepSubmitted
                  ? 'Update Schedule'
                  : 'Schedule Inspection'
              }}
            </button>
            }@else{
            <wm-common-button
              class="inspection-button"
              [data]="{
              text:activity.scheduleStepSubmitted
                ? 'Update Schedule'
                : 'Schedule Inspection',
              disabled: !!activity.model.inspection.downloadedToTabletOn 
                || uploadedInspectionPending 
                || scheduleStepForm.invalid
                || processing,
              onClick: submitScheduleStep.bind(this)
            }"
            >
            </wm-common-button>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Complete Step -->
    <div class="card">
      <div class="card-header" id="headingCompleteStep">
        <div class="d-flex justify-content-between">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              [attr.aria-expanded]="expandedStep === InspectionStep.Complete"
              (click)="expandCompleteStep()"
            >
              Complete {{ activity.model.inspectionType }} Inspection
            </button>
          </h5>
          <span
            *ngIf="activity.status === ActivityStatus.Completed"
            class="text-success ml-2"
            title="Submitted"
          >
            &#10003;
          </span>
          <span
            *ngIf="activity.status !== ActivityStatus.Completed"
            class="text-muted ml-2"
            title="Not submitted"
          >
            &#9711;
          </span>
        </div>
      </div>
      <div
        [ngClass]="{
          collapse: expandedStep !== InspectionStep.Complete,
          show: expandedStep === InspectionStep.Complete
        }"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <wm-form-activity-input-view
                #completeStepInput
                [activity]="activity.model.completeStepActivity"
                [calculationActivity]="activity"
                [form]="completeStepForm"
                [applicationId]="applicationId"
              ></wm-form-activity-input-view>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            @if(!templateForPermitForm){

            <button
              class="btn btn-primary btn-raised"
              [disabled]="
                uploadedInspectionPending ||
                completeStepForm.invalid ||
                processing
              "
              (click)="submitCompleteStep()"
            >
              {{
                activity.status === ActivityStatus.Completed
                  ? 'Update Inspection'
                  : 'Complete Inspection'
              }}
            </button>
            }@else{
            <wm-common-button
              class="inspection-button"
              [data]="{
              text: activity.status === ActivityStatus.Completed
                ? 'Update Inspection'
                : 'Complete Inspection',
              disabled: uploadedInspectionPending 
                || completeStepForm.invalid 
                || processing,
              onClick: submitCompleteStep.bind(this)
            }"
            >
            </wm-common-button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
